import React, { useMemo } from 'react';
import { Outlet } from 'react-router-dom';

import useClassnames from 'hook/use-classnames';

import './img/favicon.ico';
import { IProps } from './types';
import style from './index.pcss';

const Layout: React.FC<IProps> = () => {
    const cn = useMemo(() => useClassnames(style), []);

    return (
        <div className={cn('layout')}>
            <div className={cn('layout__inner')}>
                <Outlet />
            </div>
        </div>
    );
};

export default Layout;
